export const FBW_SEARCH_NETWORKS = 'fbw/SEARCH_NETWORKS';
export const FBW_SEARCH_NETWORKS_SUCCESS = 'fbw/SEARCH_NETWORKS_SUCCESS';
export const FBW_SEARCH_NETWORKS_ERROR = 'fbw/SEARCH_NETWORKS_ERROR';

export const FBW_SET_NETWORK = 'fbw/SET_NETWORK';
export const FBW_SET_NETWORK_SUCCESS = 'fbw/SET_NETWORK_SUCCESS';
export const FBW_SET_NETWORK_ERROR = 'fbw/SEARCH_NETWORK_ERROR';

export const FBW_CREATE_NETWORK = 'fbw/SEARCH_NETWORK';
export const FBW_CREATE_NETWORK_SUCCESS = 'fbw/SEARCH_NETWORK_SUCCESS';
export const FBW_CREATE_NETWORK_ERROR = 'fbw/SEARCH_NETWORK_ERROR';
